import { useEffect, useState } from "react";
import { api } from "../services/api";
import "./Footer.css";

export default function Footer() {
  const [site, setSite] = useState(null);

  useEffect(() => {
    async function loadFooterData() {
      try {
        // ==========================================
        // 1. LÓGICA DE PRODUÇÃO (SUBDOMÍNIO)
        // Descomente a linha abaixo quando for para produção (ex: instituto.sistemapercept.com.br)
        // ==========================================
        const cliente = window.location.hostname.split(".")[0];

        // ==========================================
        // 2. LÓGICA DE DESENVOLVIMENTO (ROTAS)
        // Captura o cliente pela rota (ex: .com.br/instituto/ ou localhost:3000/instituto/)
        // ==========================================
        // const cliente = window.location.pathname.split("/")[1];

        // Faz a requisição para a rota que criamos no controller
        const response = await api.get(`/site-config?client=${cliente}`);
        setSite(response.data);
      } catch (error) {
        console.error("Erro ao carregar os dados do rodapé do banco:", error);
      }
    }

    loadFooterData();
  }, []);

  // Aguarda a resposta da API antes de renderizar (considerando que sempre haverá dados)
  if (!site) return null;

  return (
    <footer className="main-footer">
      <div className="container footer-content">
        
        {/* COLUNA 1: INSTITUCIONAL - TEXTOS FORTES */}
        <div className="footer-col info-box">
          <h2 className="impresb-name">{site.nome}</h2>
          
          <div className="contact-details">
            <p><strong>CNPJ:</strong> {site.rodape.cnpj}</p>
            <p><strong>Endereço:</strong> {site.rodape.endereco}</p>
            <p><strong>Contato:</strong> {site.rodape.telefone}</p>
            <p><strong>E-mail:</strong> {site.rodape.email}</p>
          </div>
        </div>

        {/* COLUNA 2: LINKS - MAIORES E EM NEGRITO */}
        <div className="footer-col links-box">
          <h4 className="footer-title">Acesso Rápido</h4>
          <nav className="footer-nav">
            <a href="/governanca">GOVERNANÇA CORPORATIVA</a>
            <a href="/transparencia">PORTAL DA TRANSPARÊNCIA</a>
            <a href="/controles">CONTROLES INTERNOS</a>
            <a href="/educacao">EDUCAÇÃO PREVIDENCIÁRIA</a>
          </nav>
        </div>

        {/* COLUNA 3: PARCEIROS - CENTRALIZADO */}
        <div className="footer-col partners-box">
          <h4 className="footer-title">Nossos Parceiros</h4>
          <div className="logo-card">
            {/* Logo da empresa desenvolvedora restaurada e agora clicável */}
            <a href="https://sistemapercept.com.br" target="_blank" rel="noopener noreferrer">
              <img src="/assets/LOGO 2.png" alt="Sistema Percept - Desenvolvedor" />
            </a>
          </div>
        </div>

      </div>

      <div className="footer-copyright">
        <div className="container">
          <p>© 2026 <strong>PERCEPT</strong>. TODOS OS DIREITOS RESERVADOS.</p>
        </div>
      </div>
    </footer>
  );
}